

export class PrintBookingPDF{
    constructor(){

    }
    public Id:string;
    public User:string;
    public Password:string;
    public AgrisSession:string;
    public SessionId:string;
    public TenantId:string;
    public BankCode:string;
    public getPDF:boolean;
    public DownloadPDF:boolean;
    public Approved:boolean;
    public Pending :boolean;
}
